import { AccountCategory, AccountType } from "./Constants";


export const placeOfSupplyList = [
  {
    "type": "States",
    "country_nm": "India",
    "state_nm": "35 - Andaman and Nicobar Islands",
    "state_label": "Andaman and Nicobar Islands",
    "state_code": "35",
    "key": "AN"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "37 - Andhra Pradesh",
    "state_label": "Andhra Pradesh",
    "state_code": "37",
    "key": "AP"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "12 - Arunachal Pradesh",
    "state_label": "Arunachal Pradesh",
    "state_code": "12",
    "key": "AR"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "18 - Assam",
    "state_label": "Assam",
    "state_code": "18",
    "key": "AS"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "10 - Bihar",
    "state_label": "Bihar",
    "state_code": "10",
    "key": "BR"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "04 - Chandigarh",
    "state_label": "Chandigarh",
    "state_code": "04",
    "key": "CG"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "22 - Chhattisgarh",
    "state_label": "Chhattisgarh",
    "state_code": "22",
    "key": "CH"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "26 - Dadra and Nagar Haveli",
    "state_label": "Dadra and Nagar Haveli",
    "state_code": "26",
    "key": "DH"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "25 - Daman and Diu",
    "state_label": "Daman and Diu",
    "state_code": "25",
    "key": "DD"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "07 - Delhi",
    "state_label": "Delhi",
    "state_code": "07",
    "key": "DL"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "30 - Goa",
    "state_label": "Goa",
    "state_code": "30",
    "key": "GA"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "24 - Gujarat",
    "state_label": "Gujarat",
    "state_code": "24",
    "key": "GJ"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "06 - Haryana",
    "state_label": "Haryana",
    "state_code": "06",
    "key": "HR"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "02 - Himachal Pradesh",
    "state_label": "Himachal Pradesh",
    "state_code": "02",
    "key": "HP"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "01 - Jammu and Kashmir",
    "state_label": "Jammu and Kashmir",
    "state_code": "01",
    "key": "JK"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "20 - Jharkhand",
    "state_label": "Jharkhand",
    "state_code": "20",
    "key": "JH"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "29 - Karnataka",
    "state_label": "Karnataka",
    "state_code": "29",
    "key": "KA"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "32 - Kerala",
    "state_label": "Kerala",
    "state_code": "32",
    "key": "KL"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "31 - Lakshadweep",
    "state_label": "Lakshadweep",
    "state_code": "31",
    "key": "LD"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "23 - Madhya Pradesh",
    "state_label": "Madhya Pradesh",
    "state_code": "23",
    "key": "MP"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "27 - Maharashtra",
    "state_label": "Maharashtra",
    "state_code": "27",
    "key": "MH"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "14 - Manipur",
    "state_label": "Manipur",
    "state_code": "14",
    "key": "MN"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "17 - Meghalaya",
    "state_label": "Meghalaya",
    "state_code": "17",
    "key": "ML"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "15 - Mizoram",
    "state_label": "Mizoram",
    "state_code": "15",
    "key": "MZ"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "13 - Nagaland",
    "state_label": "Nagaland",
    "state_code": "13",
    "key": "NL"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "21 - Odisha",
    "state_label": "Odisha",
    "state_code": "21",
    "key": "OR"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "34 - Puducherry",
    "state_label": "Puducherry",
    "state_code": "34",
    "key": "PY"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "03 - Punjab",
    "state_label": "Punjab",
    "state_code": "03",
    "key": "PB"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "08 - Rajasthan",
    "state_label": "Rajasthan",
    "state_code": "08",
    "key": "RJ"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "11 - Sikkim",
    "state_label": "Sikkim",
    "state_code": "11",
    "key": "SK"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "33 - Tamil Nadu",
    "state_label": "Tamil Nadu",
    "state_code": "33",
    "key": "TN"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "36 - Telangana",
    "state_label": "Telangana",
    "state_code": "36",
    "key": "TS"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "16 - Tripura",
    "state_label": "Tripura",
    "state_code": "16",
    "key": "TR"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "05 - Uttarakhand",
    "state_label": "Uttarakhand",
    "state_code": "05",
    "key": "UK"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "09 - Uttar Pradesh",
    "state_label": "Uttar Pradesh",
    "state_code": "09",
    "key": "UP"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "19 - West Bengal",
    "state_label": "West Bengal",
    "state_code": "19",
    "key": "WB"
  }, {
    "type": "States",
    "country_nm": "India",
    "state_nm": "Overseas",
    "state_label": "Overseas",
    "state_code": "",
    "key": ""
  }
]

export const CountryList = [
  {"isoCode":"AF","countryName":"Afghanistan","currencyCode":"AFN","currencySymbol":"؋","languageCode":"fa","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Kabul"},
  {"isoCode":"AL","countryName":"Albania","currencyCode":"ALL","currencySymbol":"Lek","languageCode":"sq","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Tirane"},
  {"isoCode":"DZ","countryName":"Algeria","currencyCode":"DZD","currencySymbol":"دج","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Algiers"},
  {"isoCode":"AD","countryName":"Andorra","currencyCode":"EUR","currencySymbol":"€","languageCode":"ca","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Andorra"},
  {"isoCode":"AO","countryName":"Angola","currencyCode":"AOA","currencySymbol":"Kz","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-Standard-April-March","timeZone":"Africa/Luanda"},
  {"isoCode":"AG","countryName":"Antigua and Barbuda","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Antigua"},
  {"isoCode":"AR","countryName":"Argentina","currencyCode":"ARS","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-Standard-July-June","timeZone":"America/Argentina/Buenos_Aires"},
  {"isoCode":"AM","countryName":"Armenia","currencyCode":"AMD","currencySymbol":"֏","languageCode":"hy","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Yerevan"},
  {"isoCode":"AU","countryName":"Australia","currencyCode":"AUD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-Standard-July-June","timeZone":"Australia/Sydney"},
  {"isoCode":"AT","countryName":"Austria","currencyCode":"EUR","currencySymbol":"€","languageCode":"de","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Vienna"},
  {"isoCode":"AZ","countryName":"Azerbaijan","currencyCode":"AZN","currencySymbol":"₼","languageCode":"az","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Baku"},
  {"isoCode":"BS","countryName":"Bahamas","currencyCode":"BSD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Nassau"},
  {"isoCode":"BH","countryName":"Bahrain","currencyCode":"BHD","currencySymbol":"ب.د","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Bahrain"},
  {"isoCode":"BD","countryName":"Bangladesh","currencyCode":"BDT","currencySymbol":"৳","languageCode":"bn","resourceId":null,"fiscalYearId":"FY-July-July","timeZone":"Asia/Dhaka"},
  {"isoCode":"BB","countryName":"Barbados","currencyCode":"BBD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Barbados"},
  {"isoCode":"BY","countryName":"Belarus","currencyCode":"BYN","currencySymbol":"Br","languageCode":"be","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Minsk"},
  {"isoCode":"BE","countryName":"Belgium","currencyCode":"EUR","currencySymbol":"€","languageCode":"nl","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Brussels"},
  {"isoCode":"BZ","countryName":"Belize","currencyCode":"BZD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Belize"},
  {"isoCode":"BJ","countryName":"Benin","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Porto-Novo"},
  {"isoCode":"BT","countryName":"Bhutan","currencyCode":"BTN","currencySymbol":"₨","languageCode":"dz","resourceId":null,"fiscalYearId":"FY-July-July","timeZone":"Asia/Thimphu"},
  {"isoCode":"BO","countryName":"Bolivia","currencyCode":"BOB","currencySymbol":"$b","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/La_Paz"},
  {"isoCode":"BA","countryName":"Bosnia and Herzegovina","currencyCode":"BAM","currencySymbol":"КМ","languageCode":"bs","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Sarajevo"},
  {"isoCode":"BW","countryName":"Botswana","currencyCode":"BWP","currencySymbol":"P","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Gaborone"},
  {"isoCode":"BR","countryName":"Brazil","currencyCode":"BRL","currencySymbol":"R$","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Sao_Paulo"},
  {"isoCode":"BN","countryName":"Brunei","currencyCode":"BND","currencySymbol":"$","languageCode":"ms","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Brunei"},
  {"isoCode":"BG","countryName":"Bulgaria","currencyCode":"BGN","currencySymbol":"лв","languageCode":"bg","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Sofia"},
  {"isoCode":"BF","countryName":"Burkina Faso","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Ouagadougou"},
  {"isoCode":"BI","countryName":"Burundi","currencyCode":"BIF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Bujumbura"},
  {"isoCode":"CV","countryName":"Cabo Verde","currencyCode":"CVE","currencySymbol":"$","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Atlantic/Cape_Verde"},
  {"isoCode":"KH","countryName":"Cambodia","currencyCode":"KHR","currencySymbol":"៛","languageCode":"km","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Phnom_Penh"},
  {"isoCode":"CM","countryName":"Cameroon","currencyCode":"XAF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Douala"},
  {"isoCode":"CA","countryName":"Canada","currencyCode":"CAD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Toronto"},
  {"isoCode":"CF","countryName":"Central African Republic","currencyCode":"XAF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Bangui"},
  {"isoCode":"TD","countryName":"Chad","currencyCode":"XAF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Ndjamena"},
  {"isoCode":"CL","countryName":"Chile","currencyCode":"CLP","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Santiago"},
  {"isoCode":"CN","countryName":"China","currencyCode":"CNY","currencySymbol":"¥","languageCode":"zh","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Shanghai"},
  {"isoCode":"CO","countryName":"Colombia","currencyCode":"COP","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Bogota"},
  {"isoCode":"KM","countryName":"Comoros","currencyCode":"KMF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Indian/Comoro"},
  {"isoCode":"CR","countryName":"Costa Rica","currencyCode":"CRC","currencySymbol":"₡","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Costa_Rica"},
  {"isoCode":"HR","countryName":"Croatia","currencyCode":"HRK","currencySymbol":"kn","languageCode":"hr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Zagreb"},
  {"isoCode":"CU","countryName":"Cuba","currencyCode":"CUP","currencySymbol":"₱","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Havana"},
  {"isoCode":"CY","countryName":"Cyprus","currencyCode":"EUR","currencySymbol":"€","languageCode":"el","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Nicosia"},
  {"isoCode":"CZ","countryName":"Czechia (Czech Republic)","currencyCode":"CZK","currencySymbol":"Kč","languageCode":"cs","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Prague"},
  {"isoCode":"DK","countryName":"Denmark","currencyCode":"DKK","currencySymbol":"kr","languageCode":"da","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Copenhagen"},
  {"isoCode":"DJ","countryName":"Djibouti","currencyCode":"DJF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Djibouti"},
  {"isoCode":"DM","countryName":"Dominica","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Dominica"},
  {"isoCode":"DO","countryName":"Dominican Republic","currencyCode":"DOP","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Santo_Domingo"},
  {"isoCode":"EC","countryName":"Ecuador","currencyCode":"USD","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Guayaquil"},
  {"isoCode":"EG","countryName":"Egypt","currencyCode":"EGP","currencySymbol":"£","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Cairo"},
  {"isoCode":"SV","countryName":"El Salvador","currencyCode":"USD","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/El_Salvador"},
  {"isoCode":"GQ","countryName":"Equatorial Guinea","currencyCode":"XAF","currencySymbol":"₣","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Malabo"},
  {"isoCode":"ER","countryName":"Eritrea","currencyCode":"ERN","currencySymbol":"Nfk","languageCode":"ti","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Asmara"},
  {"isoCode":"EE","countryName":"Estonia","currencyCode":"EUR","currencySymbol":"€","languageCode":"et","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Tallinn"},
  {"isoCode":"ET","countryName":"Ethiopia","currencyCode":"ETB","currencySymbol":"Br","languageCode":"am","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Addis_Ababa"},
  {"isoCode":"FJ","countryName":"Fiji","currencyCode":"FJD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Fiji"},
  {"isoCode":"FI","countryName":"Finland","currencyCode":"EUR","currencySymbol":"€","languageCode":"fi","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Helsinki"},
  {"isoCode":"FR","countryName":"France","currencyCode":"EUR","currencySymbol":"€","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Paris"},
  {"isoCode":"GA","countryName":"Gabon","currencyCode":"XAF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Libreville"},
  {"isoCode":"GM","countryName":"Gambia","currencyCode":"GMD","currencySymbol":"D","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Banjul"},
  {"isoCode":"GE","countryName":"Georgia","currencyCode":"GEL","currencySymbol":"₾","languageCode":"ka","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Tbilisi"},
  {"isoCode":"DE","countryName":"Germany","currencyCode":"EUR","currencySymbol":"€","languageCode":"de","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Berlin"},
  {"isoCode":"GH","countryName":"Ghana","currencyCode":"GHS","currencySymbol":"₵","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Accra"},
  {"isoCode":"GR","countryName":"Greece","currencyCode":"EUR","currencySymbol":"€","languageCode":"el","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Athens"},
  {"isoCode":"GD","countryName":"Grenada","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Grenada"},
  {"isoCode":"GT","countryName":"Guatemala","currencyCode":"GTQ","currencySymbol":"Q","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Guatemala"},
  {"isoCode":"GN","countryName":"Guinea","currencyCode":"GNF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Conakry"},
  {"isoCode":"GW","countryName":"Guinea-Bissau","currencyCode":"XOF","currencySymbol":"₣","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Bissau"},
  {"isoCode":"GY","countryName":"Guyana","currencyCode":"GYD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Guyana"},
  {"isoCode":"HT","countryName":"Haiti","currencyCode":"HTG","currencySymbol":"G","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Port-au-Prince"},
  {"isoCode":"HN","countryName":"Honduras","currencyCode":"HNL","currencySymbol":"L","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Tegucigalpa"},
  {"isoCode":"HU","countryName":"Hungary","currencyCode":"HUF","currencySymbol":"Ft","languageCode":"hu","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Budapest"},
  {"isoCode":"IS","countryName":"Iceland","currencyCode":"ISK","currencySymbol":"kr","languageCode":"is","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Atlantic/Reykjavik"},
  {"isoCode":"IN","countryName":"India","currencyCode":"INR","currencySymbol":"₹","languageCode":"hi","resourceId":null,"fiscalYearId":"FY-Standard-April-March","timeZone":"Asia/Kolkata"},
  {"isoCode":"ID","countryName":"Indonesia","currencyCode":"IDR","currencySymbol":"Rp","languageCode":"id","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Jakarta"},
  {"isoCode":"IR","countryName":"Iran","currencyCode":"IRR","currencySymbol":"﷼","languageCode":"fa","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Tehran"},
  {"isoCode":"IQ","countryName":"Iraq","currencyCode":"IQD","currencySymbol":"ع.د","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Baghdad"},
  {"isoCode":"IE","countryName":"Ireland","currencyCode":"EUR","currencySymbol":"€","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Dublin"},
  {"isoCode":"IL","countryName":"Israel","currencyCode":"ILS","currencySymbol":"₪","languageCode":"he","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Jerusalem"},
  {"isoCode":"IT","countryName":"Italy","currencyCode":"EUR","currencySymbol":"€","languageCode":"it","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Rome"},
  {"isoCode":"CI","countryName":"Ivory Coast (Côte d'Ivoire)","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Abidjan"},
  {"isoCode":"JM","countryName":"Jamaica","currencyCode":"JMD","currencySymbol":"J$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Jamaica"},
  {"isoCode":"JP","countryName":"Japan","currencyCode":"JPY","currencySymbol":"¥","languageCode":"ja","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Tokyo"},
  {"isoCode":"JO","countryName":"Jordan","currencyCode":"JOD","currencySymbol":"د.ا","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Amman"},
  {"isoCode":"KZ","countryName":"Kazakhstan","currencyCode":"KZT","currencySymbol":"₸","languageCode":"ru","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Almaty"},
  {"isoCode":"KE","countryName":"Kenya","currencyCode":"KES","currencySymbol":"Sh","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Nairobi"},
  {"isoCode":"KI","countryName":"Kiribati","currencyCode":"AUD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Tarawa"},
  {"isoCode":"KP","countryName":"North Korea","currencyCode":"KPW","currencySymbol":"₩","languageCode":"ko","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Pyongyang"},
  {"isoCode":"KR","countryName":"South Korea","currencyCode":"KRW","currencySymbol":"₩","languageCode":"ko","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Seoul"},
  {"isoCode":"KW","countryName":"Kuwait","currencyCode":"KWD","currencySymbol":"د.ك","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Kuwait"},
  {"isoCode":"KG","countryName":"Kyrgyzstan","currencyCode":"KGS","currencySymbol":"сом","languageCode":"ky","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Bishkek"},
  {"isoCode":"LA","countryName":"Laos","currencyCode":"LAK","currencySymbol":"₭","languageCode":"lo","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Vientiane"},
  {"isoCode":"LV","countryName":"Latvia","currencyCode":"EUR","currencySymbol":"€","languageCode":"lv","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Riga"},
  {"isoCode":"LB","countryName":"Lebanon","currencyCode":"LBP","currencySymbol":"ل.ل","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Beirut"},
  {"isoCode":"LS","countryName":"Lesotho","currencyCode":"LSL","currencySymbol":"L","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Maseru"},
  {"isoCode":"LR","countryName":"Liberia","currencyCode":"LRD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Monrovia"},
  {"isoCode":"LY","countryName":"Libya","currencyCode":"LYD","currencySymbol":"ل.د","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Tripoli"},
  {"isoCode":"LI","countryName":"Liechtenstein","currencyCode":"CHF","currencySymbol":"CHf","languageCode":"de","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Vaduz"},
  {"isoCode":"LT","countryName":"Lithuania","currencyCode":"EUR","currencySymbol":"€","languageCode":"lt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Vilnius"},
  {"isoCode":"LU","countryName":"Luxembourg","currencyCode":"EUR","currencySymbol":"€","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Luxembourg"},
  {"isoCode":"MG","countryName":"Madagascar","currencyCode":"MGA","currencySymbol":"Ar","languageCode":"mg","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Indian/Antananarivo"},
  {"isoCode":"MW","countryName":"Malawi","currencyCode":"MWK","currencySymbol":"MK","languageCode":"ny","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Blantyre"},
  {"isoCode":"MY","countryName":"Malaysia","currencyCode":"MYR","currencySymbol":"RM","languageCode":"ms","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Kuala_Lumpur"},
  {"isoCode":"MV","countryName":"Maldives","currencyCode":"MVR","currencySymbol":"ރ.","languageCode":"dv","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Indian/Maldives"},
  {"isoCode":"ML","countryName":"Mali","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Bamako"},
  {"isoCode":"MT","countryName":"Malta","currencyCode":"EUR","currencySymbol":"€","languageCode":"mt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Malta"},
  {"isoCode":"MH","countryName":"Marshall Islands","currencyCode":"USD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Majuro"},
  {"isoCode":"MR","countryName":"Mauritania","currencyCode":"MRO","currencySymbol":"UM","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Nouakchott"},
  {"isoCode":"MU","countryName":"Mauritius","currencyCode":"MUR","currencySymbol":"₨","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Indian/Mauritius"},
  {"isoCode":"MX","countryName":"Mexico","currencyCode":"MXN","currencySymbol":"$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Mexico_City"},
  {"isoCode":"FM","countryName":"Micronesia","currencyCode":"USD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Pohnpei"},
  {"isoCode":"MD","countryName":"Moldova","currencyCode":"MDL","currencySymbol":"L","languageCode":"ro","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Chisinau"},
  {"isoCode":"MC","countryName":"Monaco","currencyCode":"EUR","currencySymbol":"€","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Monaco"},
  {"isoCode":"MN","countryName":"Mongolia","currencyCode":"MNT","currencySymbol":"₮","languageCode":"mn","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Ulaanbaatar"},
  {"isoCode":"ME","countryName":"Montenegro","currencyCode":"EUR","currencySymbol":"€","languageCode":"sr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Podgorica"},
  {"isoCode":"MA","countryName":"Morocco","currencyCode":"MAD","currencySymbol":"د.م.","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Casablanca"},
  {"isoCode":"MZ","countryName":"Mozambique","currencyCode":"MZN","currencySymbol":"MT","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Maputo"},
  {"isoCode":"MM","countryName":"Myanmar (Burma)","currencyCode":"MMK","currencySymbol":"Ks","languageCode":"my","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Yangon"},
  {"isoCode":"NA","countryName":"Namibia","currencyCode":"NAD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Windhoek"},
  {"isoCode":"NR","countryName":"Nauru","currencyCode":"AUD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Nauru"},
  {"isoCode":"NP","countryName":"Nepal","currencyCode":"NPR","currencySymbol":"₨","languageCode":"ne","resourceId":null,"fiscalYearId":"FY-July-July","timeZone":"Asia/Kathmandu"},
  {"isoCode":"NL","countryName":"Netherlands","currencyCode":"EUR","currencySymbol":"€","languageCode":"nl","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Amsterdam"},
  {"isoCode":"NZ","countryName":"New Zealand","currencyCode":"NZD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-Standard-July-June","timeZone":"Pacific/Auckland"},
  {"isoCode":"NI","countryName":"Nicaragua","currencyCode":"NIO","currencySymbol":"C$","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Managua"},
  {"isoCode":"NE","countryName":"Niger","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Niamey"},
  {"isoCode":"NG","countryName":"Nigeria","currencyCode":"NGN","currencySymbol":"₦","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Lagos"},
  {"isoCode":"NO","countryName":"Norway","currencyCode":"NOK","currencySymbol":"kr","languageCode":"no","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Oslo"},
  {"isoCode":"OM","countryName":"Oman","currencyCode":"OMR","currencySymbol":"ر.ع.","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Muscat"},
  {"isoCode":"PK","countryName":"Pakistan","currencyCode":"PKR","currencySymbol":"₨","languageCode":"ur","resourceId":null,"fiscalYearId":"FY-July-July","timeZone":"Asia/Karachi"},
  {"isoCode":"PW","countryName":"Palau","currencyCode":"USD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Palau"},
  {"isoCode":"PA","countryName":"Panama","currencyCode":"PAB","currencySymbol":"B/.","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Panama"},
  {"isoCode":"PG","countryName":"Papua New Guinea","currencyCode":"PGK","currencySymbol":"K","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Port_Moresby"},
  {"isoCode":"PY","countryName":"Paraguay","currencyCode":"PYG","currencySymbol":"₲","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Asuncion"},
  {"isoCode":"PE","countryName":"Peru","currencyCode":"PEN","currencySymbol":"S/.","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Lima"},
  {"isoCode":"PH","countryName":"Philippines","currencyCode":"PHP","currencySymbol":"₱","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Manila"},
  {"isoCode":"PL","countryName":"Poland","currencyCode":"PLN","currencySymbol":"zł","languageCode":"pl","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Warsaw"},
  {"isoCode":"PT","countryName":"Portugal","currencyCode":"EUR","currencySymbol":"€","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Lisbon"},
  {"isoCode":"QA","countryName":"Qatar","currencyCode":"QAR","currencySymbol":"ر.ق","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Qatar"},
  {"isoCode":"RO","countryName":"Romania","currencyCode":"RON","currencySymbol":"lei","languageCode":"ro","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Bucharest"},
  {"isoCode":"RU","countryName":"Russia","currencyCode":"RUB","currencySymbol":"₽","languageCode":"ru","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Moscow"},
  {"isoCode":"RW","countryName":"Rwanda","currencyCode":"RWF","currencySymbol":"₣","languageCode":"rw","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Kigali"},
  {"isoCode":"KN","countryName":"Saint Kitts and Nevis","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/St_Kitts"},
  {"isoCode":"LC","countryName":"Saint Lucia","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/St_Lucia"},
  {"isoCode":"VC","countryName":"Saint Vincent and the Grenadines","currencyCode":"XCD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/St_Vincent"},
  {"isoCode":"WS","countryName":"Samoa","currencyCode":"WST","currencySymbol":"T","languageCode":"sm","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Apia"},
  {"isoCode":"SM","countryName":"San Marino","currencyCode":"EUR","currencySymbol":"€","languageCode":"it","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/San_Marino"},
  {"isoCode":"ST","countryName":"Sao Tome and Principe","currencyCode":"STD","currencySymbol":"Db","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Sao_Tome"},
  {"isoCode":"SA","countryName":"Saudi Arabia","currencyCode":"SAR","currencySymbol":"ر.س","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Riyadh"},
  {"isoCode":"SN","countryName":"Senegal","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Dakar"},
  {"isoCode":"RS","countryName":"Serbia","currencyCode":"RSD","currencySymbol":"дин","languageCode":"sr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Belgrade"},
  {"isoCode":"SC","countryName":"Seychelles","currencyCode":"SCR","currencySymbol":"₨","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Indian/Mahe"},
  {"isoCode":"SL","countryName":"Sierra Leone","currencyCode":"SLL","currencySymbol":"Le","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Freetown"},
  {"isoCode":"SG","countryName":"Singapore","currencyCode":"SGD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Singapore"},
  {"isoCode":"SK","countryName":"Slovakia","currencyCode":"EUR","currencySymbol":"€","languageCode":"sk","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Bratislava"},
  {"isoCode":"SI","countryName":"Slovenia","currencyCode":"EUR","currencySymbol":"€","languageCode":"sl","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Ljubljana"},
  {"isoCode":"SB","countryName":"Solomon Islands","currencyCode":"SBD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Guadalcanal"},
  {"isoCode":"SO","countryName":"Somalia","currencyCode":"SOS","currencySymbol":"Sh","languageCode":"so","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Mogadishu"},
  {"isoCode":"ZA","countryName":"South Africa","currencyCode":"ZAR","currencySymbol":"R","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Johannesburg"},
  {"isoCode":"ES","countryName":"Spain","currencyCode":"EUR","currencySymbol":"€","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Madrid"},
  {"isoCode":"LK","countryName":"Sri Lanka","currencyCode":"LKR","currencySymbol":"₨","languageCode":"si","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Colombo"},
  {"isoCode":"SD","countryName":"Sudan","currencyCode":"SDG","currencySymbol":"ج.س.","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Khartoum"},
  {"isoCode":"SR","countryName":"Suriname","currencyCode":"SRD","currencySymbol":"$","languageCode":"nl","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Paramaribo"},
  {"isoCode":"SZ","countryName":"Swaziland","currencyCode":"SZL","currencySymbol":"L","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Mbabane"},
  {"isoCode":"SE","countryName":"Sweden","currencyCode":"SEK","currencySymbol":"kr","languageCode":"sv","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Stockholm"},
  {"isoCode":"CH","countryName":"Switzerland","currencyCode":"CHF","currencySymbol":"CHF","languageCode":"de","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Zurich"},
  {"isoCode":"SY","countryName":"Syria","currencyCode":"SYP","currencySymbol":"£","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Damascus"},
  {"isoCode":"TW","countryName":"Taiwan","currencyCode":"TWD","currencySymbol":"$","languageCode":"zh","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Taipei"},
  {"isoCode":"TJ","countryName":"Tajikistan","currencyCode":"TJS","currencySymbol":"ЅМ","languageCode":"tg","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Dushanbe"},
  {"isoCode":"TZ","countryName":"Tanzania","currencyCode":"TZS","currencySymbol":"Sh","languageCode":"sw","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Dar_es_Salaam"},
  {"isoCode":"TH","countryName":"Thailand","currencyCode":"THB","currencySymbol":"฿","languageCode":"th","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Bangkok"},
  {"isoCode":"TL","countryName":"Timor-Leste","currencyCode":"USD","currencySymbol":"$","languageCode":"pt","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Dili"},
  {"isoCode":"TG","countryName":"Togo","currencyCode":"XOF","currencySymbol":"₣","languageCode":"fr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Lome"},
  {"isoCode":"TO","countryName":"Tonga","currencyCode":"TOP","currencySymbol":"T$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Tongatapu"},
  {"isoCode":"TT","countryName":"Trinidad and Tobago","currencyCode":"TTD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Port_of_Spain"},
  {"isoCode":"TN","countryName":"Tunisia","currencyCode":"TND","currencySymbol":"د.ت","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Tunis"},
  {"isoCode":"TR","countryName":"Turkey","currencyCode":"TRY","currencySymbol":"₺","languageCode":"tr","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Istanbul"},
  {"isoCode":"TM","countryName":"Turkmenistan","currencyCode":"TMT","currencySymbol":"m","languageCode":"tk","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Ashgabat"},
  {"isoCode":"TV","countryName":"Tuvalu","currencyCode":"AUD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Funafuti"},
  {"isoCode":"UG","countryName":"Uganda","currencyCode":"UGX","currencySymbol":"Sh","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Kampala"},
  {"isoCode":"UA","countryName":"Ukraine","currencyCode":"UAH","currencySymbol":"₴","languageCode":"uk","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Kiev"},
  {"isoCode":"AE","countryName":"United Arab Emirates","currencyCode":"AED","currencySymbol":"د.إ","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Dubai"},
  {"isoCode":"GB","countryName":"United Kingdom","currencyCode":"GBP","currencySymbol":"£","languageCode":"en","resourceId":null,"fiscalYearId":"FY-UK-Personal","timeZone":"Europe/London"},
  {"isoCode":"US","countryName":"United States","currencyCode":"USD","currencySymbol":"$","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/New_York"},
  {"isoCode":"UY","countryName":"Uruguay","currencyCode":"UYU","currencySymbol":"$U","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Montevideo"},
  {"isoCode":"UZ","countryName":"Uzbekistan","currencyCode":"UZS","currencySymbol":"лв","languageCode":"uz","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Tashkent"},
  {"isoCode":"VU","countryName":"Vanuatu","currencyCode":"VUV","currencySymbol":"Vt","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Pacific/Efate"},
  {"isoCode":"VA","countryName":"Vatican City","currencyCode":"EUR","currencySymbol":"€","languageCode":"it","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Europe/Vatican"},
  {"isoCode":"VE","countryName":"Venezuela","currencyCode":"VES","currencySymbol":"Bs","languageCode":"es","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"America/Caracas"},
  {"isoCode":"VN","countryName":"Vietnam","currencyCode":"VND","currencySymbol":"₫","languageCode":"vi","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Ho_Chi_Minh"},
  {"isoCode":"YE","countryName":"Yemen","currencyCode":"YER","currencySymbol":"﷼","languageCode":"ar","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Asia/Aden"},
  {"isoCode":"ZM","countryName":"Zambia","currencyCode":"ZMW","currencySymbol":"ZK","languageCode":"en","resourceId":null,"fiscalYearId":"FY-January-December","timeZone":"Africa/Lusaka"}
]

export let currencyData = [
  {
    type: "Currencies",
    currency_code: "AED-United Arab Emirates Dirham",
    currency_symbol: "د.إ",
    currency_country: "United Arab Emirates (UAE)",
  },
  {
    type: "Currencies",
    currency_code: "AFN-Afghanistan Afghani",
    currency_symbol: "؋",
    currency_country: "Afghanistan",
  },
  {
    type: "Currencies",
    currency_code: "ALL-Albania Lek",
    currency_symbol: "Lek",
    currency_country: "Albania",
  },
  {
    type: "Currencies",
    currency_code: "AMD-Armenia Dram",
    currency_symbol: "֏",
    currency_country: "Armenia",
  },
  {
    type: "Currencies",
    currency_code: "AOA-Angola Kwanza",
    currency_symbol: "Kz",
    currency_country: "Angola",
  },
  {
    type: "Currencies",
    currency_code: "ARS-Argentina Peso",
    currency_symbol: "$",
    currency_country: "Argentina",
  },
  {
    type: "Currencies",
    currency_code: "AUD-Australia Dollar",
    currency_symbol: "$",
    currency_country: "Australia",
  },
  {
    type: "Currencies",
    currency_code: "AWG-Aruba Guilder",
    currency_symbol: "ƒ",
    currency_country: "Aruba",
  },
  {
    type: "Currencies",
    currency_code: "AZN-Azerbaijan New Manat",
    currency_symbol: "₼",
    currency_country: "Azerbaijan",
  },
  {
    type: "Currencies",
    currency_code: "BAM-Bosnia and Herzegovina Convertible Marka",
    currency_symbol: "KM",
    currency_country: "Bosnia and Herzegovina",
  },
  {
    type: "Currencies",
    currency_code: "BBD-Barbados Dollar",
    currency_symbol: "Bds$",
    currency_country: "Barbados",
  },
  {
    type: "Currencies",
    currency_code: "BDT-Bangladesh Taka",
    currency_symbol: "৳",
    currency_country: "Bangladesh",
  },
  {
    type: "Currencies",
    currency_code: "BGN-Bulgaria Lev",
    currency_symbol: "Лв",
    currency_country: "Bulgaria",
  },
  {
    type: "Currencies",
    currency_code: "BHD-Bahrain Dinar",
    currency_symbol: ".د.ب",
    currency_country: "Bahrain",
  },
  {
    type: "Currencies",
    currency_code: "BIF-Burundi Franc",
    currency_symbol: "FBu",
    currency_country: "Burundi",
  },
  {
    type: "Currencies",
    currency_code: "BMD-Bermuda Dollar",
    currency_symbol: "$",
    currency_country: "Bermuda",
  },
  {
    type: "Currencies",
    currency_code: "BND-Brunei Darussalam Dollar",
    currency_symbol: "B$",
    currency_country: "Brunei Darussalam",
  },
  {
    type: "Currencies",
    currency_code: "BOB-Bolivia Boliviano",
    currency_symbol: "Bs",
    currency_country: "Bolivia",
  },
  {
    type: "Currencies",
    currency_code: "BRL-Brazil Real",
    currency_symbol: "R$",
    currency_country: "Brazil",
  },
  {
    type: "Currencies",
    currency_code: "BSD-Bahamas Dollar",
    currency_symbol: "B$",
    currency_country: "Bahamas",
  },
  {
    type: "Currencies",
    currency_code: "BTN-Bhutan Ngultrum",
    currency_symbol: "Nu.",
    currency_country: "Bhutan",
  },
  {
    type: "Currencies",
    currency_code: "BWP-Botswana Pula",
    currency_symbol: "P",
    currency_country: "Botswana",
  },
  {
    type: "Currencies",
    currency_code: "BYR-Belarus Ruble",
    currency_symbol: "Br",
    currency_country: "Belarus",
  },
  {
    type: "Currencies",
    currency_code: "BZD-Belize Dollar",
    currency_symbol: "$",
    currency_country: "Belize",
  },
  {
    type: "Currencies",
    currency_code: "CAD-Canada Dollar",
    currency_symbol: "C$",
    currency_country: "Canada",
  },
  {
    type: "Currencies",
    currency_code: "CDF-Congo/Kinshasa Franc",
    currency_symbol: "FC",
    currency_country: "Democratic Republic of the Congo",
  },
  {
    type: "Currencies",
    currency_code: "CHF-Switzerland Franc",
    currency_symbol: "Fr.",
    currency_country: "Switzerland",
  },
  {
    type: "Currencies",
    currency_code: "CLP-Chile Peso",
    currency_symbol: "$",
    currency_country: "Chile",
  },
  {
    type: "Currencies",
    currency_code: "CNY-China Yuan Renminbi",
    currency_symbol: "¥",
    currency_country: "China",
  },
  {
    type: "Currencies",
    currency_code: "COP-Colombia Peso",
    currency_symbol: "$",
    currency_country: "Colombia",
  },
  {
    type: "Currencies",
    currency_code: "CRC-Costa Rica Colon",
    currency_symbol: "₡",
    currency_country: "Costa Rica",
  },
  {
    type: "Currencies",
    currency_code: "CUC-Cuba Convertible Peso",
    currency_symbol: "CUC$",
    currency_country: "Cuba",
  },
  {
    type: "Currencies",
    currency_code: "CUP-Cuba Peso",
    currency_symbol: "$MN",
    currency_country: "Cuba",
  },
  {
    type: "Currencies",
    currency_code: "CVE-Cape Verde Escudo",
    currency_symbol: "$",
    currency_country: "Republic of Cape Verde",
  },
  {
    type: "Currencies",
    currency_code: "CZK-Czech Republic Koruna",
    currency_symbol: "Kč",
    currency_country: "Czech Republic",
  },
  {
    type: "Currencies",
    currency_code: "DJF-Djibouti Franc",
    currency_symbol: "Fdj",
    currency_country: "Djibouti",
  },
  {
    type: "Currencies",
    currency_code: "DKK-Denmark Krone",
    currency_symbol: "Kr.",
    currency_country: "Denmark",
  },
  {
    type: "Currencies",
    currency_code: "DOP-Dominican Republic Peso",
    currency_symbol: "RD$",
    currency_country: "Dominican Republic",
  },
  {
    type: "Currencies",
    currency_code: "DZD-Algeria Dinar",
    currency_symbol: "دج",
    currency_country: "Algeria",
  },
  {
    type: "Currencies",
    currency_code: "EGP-Egypt Pound",
    currency_symbol: "E£",
    currency_country: "Egypt",
  },
  {
    type: "Currencies",
    currency_code: "ERN-Eritrea Nakfa",
    currency_symbol: "نافكا",
    currency_country: "Eritrea",
  },
  {
    type: "Currencies",
    currency_code: "ETB-Ethiopia Birr",
    currency_symbol: "ብር",
    currency_country: "Ethiopia",
  },
  {
    type: "Currencies",
    currency_code: "EUR-Euro Member Countries",
    currency_symbol: "€",
    currency_country: "Euro Member Countries",
  },
  {
    type: "Currencies",
    currency_code: "FJD-Fiji Dollar",
    currency_symbol: "FJ$",
    currency_country: "Fiji",
  },
  {
    type: "Currencies",
    currency_code: "FKP-Falkland Islands (Malvinas) Pound",
    currency_symbol: "£",
    currency_country: "Falkland Islands (Malvinas)",
  },
  {
    type: "Currencies",
    currency_code: "GBP-United Kingdom Pound",
    currency_symbol: "£",
    currency_country: "United Kingdom (UK)",
  },
  {
    type: "Currencies",
    currency_code: "GEL-Georgia Lari",
    currency_symbol: "ლ",
    currency_country: "Georgia",
  },
  {
    type: "Currencies",
    currency_code: "GGP-Guernsey Pound",
    currency_symbol: "£",
    currency_country: "Guernsey",
  },
  {
    type: "Currencies",
    currency_code: "GHS-Ghana Cedi",
    currency_symbol: "GH₵",
    currency_country: "Ghana",
  },
  {
    type: "Currencies",
    currency_code: "GIP-Gibraltar Pound",
    currency_symbol: "£",
    currency_country: "Gibraltar",
  },
  {
    type: "Currencies",
    currency_code: "GMD-Gambia Dalasi",
    currency_symbol: "D",
    currency_country: "Gambia",
  },
  {
    type: "Currencies",
    currency_code: "GNF-Guinea Franc",
    currency_symbol: "GFr",
    currency_country: "Guinea",
  },
  {
    type: "Currencies",
    currency_code: "GTQ-Guatemala Quetzal",
    currency_symbol: "Q",
    currency_country: "Guatemala",
  },
  {
    type: "Currencies",
    currency_code: "GYD-Guyana Dollar",
    currency_symbol: "G$",
    currency_country: "Guyana",
  },
  {
    type: "Currencies",
    currency_code: "HKD-Hong Kong Dollar",
    currency_symbol: "HK$",
    currency_country: "Hong Kong",
  },
  {
    type: "Currencies",
    currency_code: "HNL-Honduras Lempira",
    currency_symbol: "L",
    currency_country: "Honduras",
  },
  {
    type: "Currencies",
    currency_code: "HRK-Croatia Kuna",
    currency_symbol: "kn",
    currency_country: "Croatia",
  },
  {
    type: "Currencies",
    currency_code: "HTG-Haiti Gourde",
    currency_symbol: "G",
    currency_country: "Haiti",
  },
  {
    type: "Currencies",
    currency_code: "HUF-Hungary Forint",
    currency_symbol: "Ft",
    currency_country: "Hungary",
  },
  {
    type: "Currencies",
    currency_code: "IDR-Indonesia Rupiah",
    currency_symbol: "Rp",
    currency_country: "Indonesia",
  },
  {
    type: "Currencies",
    currency_code: "ILS-Israel Shekel",
    currency_symbol: "₪",
    currency_country: "Israel",
  },
  {
    type: "Currencies",
    currency_code: "IMP-Isle of Man Pound",
    currency_symbol: "£",
    currency_country: "Isle of Man",
  },
  {
    type: "Currencies",
    currency_code: "INR-India Rupee",
    currency_symbol: "₹",
    currency_country: "India",
  },
  {
    type: "Currencies",
    currency_code: "IQD-Iraq Dinar",
    currency_symbol: "ع.د",
    currency_country: "Iraq",
  },
  {
    type: "Currencies",
    currency_code: "IRR-Iran Rial",
    currency_symbol: "﷼",
    currency_country: "Islamic Republic of Iran",
  },
  {
    type: "Currencies",
    currency_code: "ISK-Iceland Krona",
    currency_symbol: "kr",
    currency_country: "Iceland",
  },
  {
    type: "Currencies",
    currency_code: "JEP-Jersey Pound",
    currency_symbol: "£",
    currency_country: "Jersey",
  },
  {
    type: "Currencies",
    currency_code: "JMD-Jamaica Dollar",
    currency_symbol: "$",
    currency_country: "Jamaica",
  },
  {
    type: "Currencies",
    currency_code: "JOD-Jordan Dinar",
    currency_symbol: "د.ا",
    currency_country: "Jordan",
  },
  {
    type: "Currencies",
    currency_code: "JPY-Japan Yen",
    currency_symbol: "¥",
    currency_country: "Japan",
  },
  {
    type: "Currencies",
    currency_code: "KES-Kenya Shilling",
    currency_symbol: "Ksh",
    currency_country: "Kenya",
  },
  {
    type: "Currencies",
    currency_code: "KGS-Kyrgyzstan Som",
    currency_symbol: "Лв",
    currency_country: "Kyrgyzstan",
  },
  {
    type: "Currencies",
    currency_code: "KHR-Cambodia Riel",
    currency_symbol: "៛",
    currency_country: "Cambodia",
  },
  {
    type: "Currencies",
    currency_code: "KMF-Comoros Franc",
    currency_symbol: "CF",
    currency_country: "Comoros",
  },
  {
    type: "Currencies",
    currency_code: "KPW-Korea (North) Won",
    currency_symbol: "₩",
    currency_country: "Democratic People's Republic of Korea",
  },
  {
    type: "Currencies",
    currency_code: "KRW-Korea (South) Won",
    currency_symbol: "₩",
    currency_country: "Republic of Korea",
  },
  {
    type: "Currencies",
    currency_code: "KWD-Kuwait Dinar",
    currency_symbol: "د.ك",
    currency_country: "Kuwait",
  },
  {
    type: "Currencies",
    currency_code: "KYD-Cayman Islands Dollar",
    currency_symbol: "$",
    currency_country: "Cayman Islands",
  },
  {
    type: "Currencies",
    currency_code: "KZT-Kazakhstan Tenge",
    currency_symbol: "₸",
    currency_country: "Kazakhstan",
  },
  {
    type: "Currencies",
    currency_code: "LAK-Laos Kip",
    currency_symbol: "₭",
    currency_country: "Laos",
  },
  {
    type: "Currencies",
    currency_code: "LBP-Lebanon Pound",
    currency_symbol: "ل.ل.‎",
    currency_country: "Lebanon",
  },
  {
    type: "Currencies",
    currency_code: "LKR-Sri Lanka Rupee",
    currency_symbol: "Rs",
    currency_country: "Sri Lanka",
  },
  {
    type: "Currencies",
    currency_code: "LRD-Liberia Dollar",
    currency_symbol: "L$",
    currency_country: "Liberia",
  },
  {
    type: "Currencies",
    currency_code: "LSL-Lesotho Loti",
    currency_symbol: "L",
    currency_country: "Kingdom of Lesotho",
  },
  {
    type: "Currencies",
    currency_code: "LYD-Libya Dinar",
    currency_symbol: "ل.د",
    currency_country: "Libya",
  },
  {
    type: "Currencies",
    currency_code: "MAD-Morocco Dirham",
    currency_symbol: "د. م.",
    currency_country: "Morocco",
  },
  {
    type: "Currencies",
    currency_code: "MDL-Moldova Leu",
    currency_symbol: "L",
    currency_country: "Moldova",
  },
  {
    type: "Currencies",
    currency_code: "MGA-Madagascar Ariary",
    currency_symbol: "Ar",
    currency_country: "Madagascar",
  },
  {
    type: "Currencies",
    currency_code: "MKD-Macedonia Denar",
    currency_symbol: "Ден",
    currency_country: "Republic of Macedonia",
  },
  {
    type: "Currencies",
    currency_code: "MMK-Myanmar (Burma) Kyat",
    currency_symbol: "K",
    currency_country: "Myanmar (Burma)",
  },
  {
    type: "Currencies",
    currency_code: "MNT-Mongolia Tughrik",
    currency_symbol: "₮",
    currency_country: "Mongolia",
  },
  {
    type: "Currencies",
    currency_code: "MOP-Macau Pataca",
    currency_symbol: "MOP$",
    currency_country: "Macau",
  },
  {
    type: "Currencies",
    currency_code: "MRO-Mauritania Ouguiya",
    currency_symbol: "UM",
    currency_country: "Mauritania",
  },
  {
    type: "Currencies",
    currency_code: "MUR-Mauritius Rupee",
    currency_symbol: "Rs",
    currency_country: "Mauritius",
  },
  {
    type: "Currencies",
    currency_code: "MVR-Maldives (Maldive Islands) Rufiyaa",
    currency_symbol: "Rf",
    currency_country: "Maldives",
  },
  {
    type: "Currencies",
    currency_code: "MWK-Malawi Kwacha",
    currency_symbol: "MK",
    currency_country: "Malawi",
  },
  {
    type: "Currencies",
    currency_code: "MXN-Mexico Peso",
    currency_symbol: "Mex$",
    currency_country: "Mexico",
  },
  {
    type: "Currencies",
    currency_code: "MYR-Malaysia Ringgit",
    currency_symbol: "RM",
    currency_country: "Malaysia",
  },
  {
    type: "Currencies",
    currency_code: "MZN-Mozambique Metical",
    currency_symbol: "MT",
    currency_country: "Mozambique",
  },
  {
    type: "Currencies",
    currency_code: "NAD-Namibia Dollar",
    currency_symbol: "N$",
    currency_country: "Namibia",
  },
  {
    type: "Currencies",
    currency_code: "NGN-Nigeria Naira",
    currency_symbol: "₦",
    currency_country: "Nigeria",
  },
  {
    type: "Currencies",
    currency_code: "NIO-Nicaragua Cordoba",
    currency_symbol: "C$",
    currency_country: "Nicaragua",
  },
  {
    type: "Currencies",
    currency_code: "NOK-Norway Krone",
    currency_symbol: "kr",
    currency_country: "Norway",
  },
  {
    type: "Currencies",
    currency_code: "NPR-Nepal Rupee",
    currency_symbol: "Rs.",
    currency_country: "Nepal",
  },
  {
    type: "Currencies",
    currency_code: "NZD-New Zealand Dollar",
    currency_symbol: "$",
    currency_country: "New Zealand",
  },
  {
    type: "Currencies",
    currency_code: "OMR-Oman Rial",
    currency_symbol: "ر.ع.",
    currency_country: "Oman",
  },
  {
    type: "Currencies",
    currency_code: "PAB-Panama Balboa",
    currency_symbol: "B/.",
    currency_country: "Panama",
  },
  {
    type: "Currencies",
    currency_code: "PEN-Peru Nuevo Sol",
    currency_symbol: "S/",
    currency_country: "Peru",
  },
  {
    type: "Currencies",
    currency_code: "PGK-Papua New Guinea Kina",
    currency_symbol: "K",
    currency_country: "Papua New Guinea",
  },
  {
    type: "Currencies",
    currency_code: "PHP-Philippines Peso",
    currency_symbol: "₱",
    currency_country: "Philippines",
  },
  {
    type: "Currencies",
    currency_code: "PKR-Pakistan Rupee",
    currency_symbol: "Rs",
    currency_country: "Pakistan",
  },
  {
    type: "Currencies",
    currency_code: "PLN-Poland Zloty",
    currency_symbol: "zł",
    currency_country: "Poland",
  },
  {
    type: "Currencies",
    currency_code: "PYG-Paraguay Guarani",
    currency_symbol: "₲",
    currency_country: "Paraguay",
  },
  {
    type: "Currencies",
    currency_code: "QAR-Qatar Riyal",
    currency_symbol: "ر.ق",
    currency_country: "Qatar",
  },
  {
    type: "Currencies",
    currency_code: "RON-Romania New Leu",
    currency_symbol: "L",
    currency_country: "Romania",
  },
  {
    type: "Currencies",
    currency_code: "RSD-Serbia Dinar",
    currency_symbol: "din",
    currency_country: "Serbia",
  },
  {
    type: "Currencies",
    currency_code: "RUB-Russia Ruble",
    currency_symbol: "₽",
    currency_country: "Russia",
  },
  {
    type: "Currencies",
    currency_code: "RWF-Rwanda Franc",
    currency_symbol: "FRw",
    currency_country: "Rwanda",
  },
  {
    type: "Currencies",
    currency_code: "SAR-Saudi Arabia Riyal",
    currency_symbol: "﷼‎",
    currency_country: "Saudi Arabia",
  },
  {
    type: "Currencies",
    currency_code: "SBD-Solomon Islands Dollar",
    currency_symbol: "Si$",
    currency_country: "Solomon Islands",
  },
  {
    type: "Currencies",
    currency_code: "SCR-Seychelles Rupee",
    currency_symbol: "SR",
    currency_country: "Seychelles",
  },
  {
    type: "Currencies",
    currency_code: "SDG-Sudan Pound",
    currency_symbol: "ج.س.",
    currency_country: "Republic of the Sudan",
  },
  {
    type: "Currencies",
    currency_code: "SEK-Sweden Krona",
    currency_symbol: "kr",
    currency_country: "Sweden",
  },
  {
    type: "Currencies",
    currency_code: "SGD-Singapore Dollar",
    currency_symbol: "S$",
    currency_country: "Singapore",
  },
  {
    type: "Currencies",
    currency_code: "SHP-Saint Helena Pound",
    currency_symbol: "£",
    currency_country: "Saint Helena",
  },
  {
    type: "Currencies",
    currency_code: "SLL-Sierra Leone Leone",
    currency_symbol: "Le",
    currency_country: "Sierra Leone",
  },
  {
    type: "Currencies",
    currency_code: "SOS-Somalia Shilling",
    currency_symbol: "Sh.so.",
    currency_country: "Somalia",
  },
  {
    type: "Currencies",
    currency_code: "SLS-Somaliland Shilling",
    currency_symbol: "Sl. Sh.",
    currency_country: "Somaliland",
  },
  {
    type: "Currencies",
    currency_code: "SRD-Suriname Dollar",
    currency_symbol: "$",
    currency_country: "Suriname",
  },
  {
    type: "Currencies",
    currency_code: "STD-São Tomé and Príncipe Dobra",
    currency_symbol: "Db",
    currency_country: "São Tomé and Príncipe",
  },
  {
    type: "Currencies",
    currency_code: "SVC-El Salvador Colon",
    currency_symbol: "C",
    currency_country: "El Salvador",
  },
  {
    type: "Currencies",
    currency_code: "SYP-Syria Pound",
    currency_symbol: "£S",
    currency_country: "Syria",
  },
  {
    type: "Currencies",
    currency_code: "SZL-Swaziland Lilangeni",
    currency_symbol: "E",
    currency_country: "Swaziland",
  },
  {
    type: "Currencies",
    currency_code: "THB-Thailand Baht",
    currency_symbol: "฿",
    currency_country: "Thailand",
  },
  {
    type: "Currencies",
    currency_code: "TJS-Tajikistan Somoni",
    currency_symbol: "ЅM",
    currency_country: "Tajikistan",
  },
  {
    type: "Currencies",
    currency_code: "TMT-Turkmenistan Manat",
    currency_symbol: "T",
    currency_country: "Turkmenistan",
  },
  {
    type: "Currencies",
    currency_code: "TND-Tunisia Dinar",
    currency_symbol: "د.ت",
    currency_country: "Tunisia",
  },
  {
    type: "Currencies",
    currency_code: "TOP-Tonga Pa'anga",
    currency_symbol: "PT",
    currency_country: "Tonga",
  },
  {
    type: "Currencies",
    currency_code: "TRY-Turkey Lira",
    currency_symbol: "₺",
    currency_country: "Turkey",
  },
  {
    type: "Currencies",
    currency_code: "TTD-Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
    currency_country: "Trinidad and Tobago",
  },
  {
    type: "Currencies",
    currency_code: "TVD-Tuvalu Dollar",
    currency_symbol: "TV$",
    currency_country: "Tuvalu",
  },
  {
    type: "Currencies",
    currency_code: "TWD-Taiwan New Dollar",
    currency_symbol: "NT$",
    currency_country: "Taiwan",
  },
  {
    type: "Currencies",
    currency_code: "TZS-Tanzania Shilling",
    currency_symbol: "TSh",
    currency_country: "Tanzania",
  },
  {
    type: "Currencies",
    currency_code: "UAH-Ukraine Hryvnia",
    currency_symbol: "₴",
    currency_country: "Ukraine",
  },
  {
    type: "Currencies",
    currency_code: "UGX-Uganda Shilling",
    currency_symbol: "USh",
    currency_country: "Uganda",
  },
  {
    type: "Currencies",
    currency_code: "USD-United States Dollar",
    currency_symbol: "$",
    currency_country: "United States Of America (USA)",
  },
  {
    type: "Currencies",
    currency_code: "UYU-Uruguay Peso",
    currency_symbol: "$U",
    currency_country: "Uruguay",
  },
  {
    type: "Currencies",
    currency_code: "UZS-Uzbekistan Som",
    currency_symbol: "лв",
    currency_country: "Uzbekistan",
  },
  {
    type: "Currencies",
    currency_code: "VEF-Venezuela Bolivar",
    currency_symbol: "Bs.",
    currency_country: "Venezuela",
  },
  {
    type: "Currencies",
    currency_code: "VND-Vietnam Dong",
    currency_symbol: "₫",
    currency_country: "Vietnam",
  },
  {
    type: "Currencies",
    currency_code: "VUV-Vanuatu Vatu",
    currency_symbol: "VT",
    currency_country: "Vanuatu",
  },
  {
    type: "Currencies",
    currency_code: "WST-Samoa Tala",
    currency_symbol: "SAT",
    currency_country: "Samoa",
  },
  {
    type: "Currencies",
    currency_code: "XCD-East Caribbean Dollar",
    currency_symbol: "$",
    currency_country: "Eastern Caribbean States",
  },
  {
    type: "Currencies",
    currency_code: "YER-Yemen Rial",
    currency_symbol: "﷼",
    currency_country: "Yemen",
  },
  {
    type: "Currencies",
    currency_code: "ZAR-South Africa Rand",
    currency_symbol: "R",
    currency_country: "South Africa",
  },
  {
    type: "Currencies",
    currency_code: "ZMW-Zambia Kwacha",
    currency_symbol: "ZK",
    currency_country: "Zambia",
  },
  {
    type: "Currencies",
    currency_code: "ZWD-Zimbabwe Dollar",
    currency_symbol: "Z$",
    currency_country: "Zimbabwe",
  },
];

export const CurrencyList = [
  {
    "currencyID": "AED",
    "symbol": "د.إ",
    "name": "United Arab Emirates Dirham"
  },
  {
    "currencyID": "AFN",
    "symbol": "؋",
    "name": "Afghanistan Afghani"
  },
  {
    "currencyID": "ALL",
    "symbol": "Lek",
    "name": "Albania Lek"
  },
  {
    "currencyID": "AMD",
    "symbol": "֏",
    "name": "Armenia Dram"
  },
  {
    "currencyID": "AOA",
    "symbol": "Kz",
    "name": "Angola Kwanza"
  },
  {
    "currencyID": "ARS",
    "symbol": "$",
    "name": "Argentina Peso"
  },
  {
    "currencyID": "AUD",
    "symbol": "$",
    "name": "Australia Dollar"
  },
  {
    "currencyID": "AWG",
    "symbol": "ƒ",
    "name": "Aruba Guilder"
  },
  {
    "currencyID": "AZN",
    "symbol": "₼",
    "name": "Azerbaijan New Manat"
  },
  {
    "currencyID": "BAM",
    "symbol": "KM",
    "name": "Bosnia and Herzegovina Convertible Marka"
  },
  {
    "currencyID": "BBD",
    "symbol": "Bds$",
    "name": "Barbados Dollar"
  },
  {
    "currencyID": "BDT",
    "symbol": "৳",
    "name": "Bangladesh Taka"
  },
  {
    "currencyID": "BGN",
    "symbol": "Лв",
    "name": "Bulgaria Lev"
  },
  {
    "currencyID": "BHD",
    "symbol": ".د.ب",
    "name": "Bahrain Dinar"
  },
  {
    "currencyID": "BIF",
    "symbol": "FBu",
    "name": "Burundi Franc"
  },
  {
    "currencyID": "BMD",
    "symbol": "$",
    "name": "Bermuda Dollar"
  },
  {
    "currencyID": "BND",
    "symbol": "B$",
    "name": "Brunei Darussalam Dollar"
  },
  {
    "currencyID": "BOB",
    "symbol": "Bs",
    "name": "Bolivia Boliviano"
  },
  {
    "currencyID": "BRL",
    "symbol": "R$",
    "name": "Brazil Real"
  },
  {
    "currencyID": "BSD",
    "symbol": "B$",
    "name": "Bahamas Dollar"
  },
  {
    "currencyID": "BTN",
    "symbol": "Nu.",
    "name": "Bhutan Ngultrum"
  },
  {
    "currencyID": "BWP",
    "symbol": "P",
    "name": "Botswana Pula"
  },
  {
    "currencyID": "BYR",
    "symbol": "Br",
    "name": "Belarus Ruble"
  },
  {
    "currencyID": "BZD",
    "symbol": "$",
    "name": "Belize Dollar"
  },
  {
    "currencyID": "CAD",
    "symbol": "C$",
    "name": "Canada Dollar"
  },
  {
    "currencyID": "CDF",
    "symbol": "FC",
    "name": "Congo/Kinshasa Franc"
  },
  {
    "currencyID": "CHF",
    "symbol": "Fr.",
    "name": "Switzerland Franc"
  },
  {
    "currencyID": "CLP",
    "symbol": "$",
    "name": "Chile Peso"
  },
  {
    "currencyID": "CNY",
    "symbol": "¥",
    "name": "China Yuan Renminbi"
  },
  {
    "currencyID": "COP",
    "symbol": "$",
    "name": "Colombia Peso"
  },
  {
    "currencyID": "CRC",
    "symbol": "₡",
    "name": "Costa Rica Colon"
  },
  {
    "currencyID": "CUC",
    "symbol": "CUC$",
    "name": "Cuba Convertible Peso"
  },
  {
    "currencyID": "CUP",
    "symbol": "$MN",
    "name": "Cuba Peso"
  },
  {
    "currencyID": "CVE",
    "symbol": "$",
    "name": "Cape Verde Escudo"
  },
  {
    "currencyID": "CZK",
    "symbol": "Kč",
    "name": "Czech Republic Koruna"
  },
  {
    "currencyID": "DJF",
    "symbol": "Fdj",
    "name": "Djibouti Franc"
  },
  {
    "currencyID": "DKK",
    "symbol": "Kr.",
    "name": "Denmark Krone"
  },
  {
    "currencyID": "DOP",
    "symbol": "RD$",
    "name": "Dominican Republic Peso"
  },
  {
    "currencyID": "DZD",
    "symbol": "دج",
    "name": "Algeria Dinar"
  },
  {
    "currencyID": "EGP",
    "symbol": "E£",
    "name": "Egypt Pound"
  },
  {
    "currencyID": "ERN",
    "symbol": "نافكا",
    "name": "Eritrea Nakfa"
  },
  {
    "currencyID": "ETB",
    "symbol": "ብር",
    "name": "Ethiopia Birr"
  },
  {
    "currencyID": "EUR",
    "symbol": "€",
    "name": "Euro Member Countries"
  },
  {
    "currencyID": "FJD",
    "symbol": "FJ$",
    "name": "Fiji Dollar"
  },
  {
    "currencyID": "FKP",
    "symbol": "£",
    "name": "Falkland Islands (Malvinas) Pound"
  },
  {
    "currencyID": "GBP",
    "symbol": "£",
    "name": "United Kingdom Pound"
  },
  {
    "currencyID": "GEL",
    "symbol": "ლ",
    "name": "Georgia Lari"
  },
  {
    "currencyID": "GGP",
    "symbol": "£",
    "name": "Guernsey Pound"
  },
  {
    "currencyID": "GHS",
    "symbol": "GH₵",
    "name": "Ghana Cedi"
  },
  {
    "currencyID": "GIP",
    "symbol": "£",
    "name": "Gibraltar Pound"
  },
  {
    "currencyID": "GMD",
    "symbol": "D",
    "name": "Gambia Dalasi"
  },
  {
    "currencyID": "GNF",
    "symbol": "GFr",
    "name": "Guinea Franc"
  },
  {
    "currencyID": "GTQ",
    "symbol": "Q",
    "name": "Guatemala Quetzal"
  },
  {
    "currencyID": "GYD",
    "symbol": "G$",
    "name": "Guyana Dollar"
  },
  {
    "currencyID": "HKD",
    "symbol": "HK$",
    "name": "Hong Kong Dollar"
  },
  {
    "currencyID": "HNL",
    "symbol": "L",
    "name": "Honduras Lempira"
  },
  {
    "currencyID": "HRK",
    "symbol": "kn",
    "name": "Croatia Kuna"
  },
  {
    "currencyID": "HTG",
    "symbol": "G",
    "name": "Haiti Gourde"
  },
  {
    "currencyID": "HUF",
    "symbol": "Ft",
    "name": "Hungary Forint"
  },
  {
    "currencyID": "IDR",
    "symbol": "Rp",
    "name": "Indonesia Rupiah"
  },
  {
    "currencyID": "ILS",
    "symbol": "₪",
    "name": "Israel Shekel"
  },
  {
    "currencyID": "IMP",
    "symbol": "£",
    "name": "Isle of Man Pound"
  },
  {
    "currencyID": "INR",
    "symbol": "₹",
    "name": "India Rupee"
  },
  {
    "currencyID": "IQD",
    "symbol": "ع.د",
    "name": "Iraq Dinar"
  },
  {
    "currencyID": "IRR",
    "symbol": "﷼",
    "name": "Iran Rial"
  },
  {
    "currencyID": "ISK",
    "symbol": "kr",
    "name": "Iceland Krona"
  },
  {
    "currencyID": "JEP",
    "symbol": "£",
    "name": "Jersey Pound"
  },
  {
    "currencyID": "JMD",
    "symbol": "$",
    "name": "Jamaica Dollar"
  },
  {
    "currencyID": "JOD",
    "symbol": "د.ا",
    "name": "Jordan Dinar"
  },
  {
    "currencyID": "JPY",
    "symbol": "¥",
    "name": "Japan Yen"
  },
  {
    "currencyID": "KES",
    "symbol": "Ksh",
    "name": "Kenya Shilling"
  },
  {
    "currencyID": "KGS",
    "symbol": "Лв",
    "name": "Kyrgyzstan Som"
  },
  {
    "currencyID": "KHR",
    "symbol": "៛",
    "name": "Cambodia Riel"
  },
  {
    "currencyID": "KMF",
    "symbol": "CF",
    "name": "Comoros Franc"
  },
  {
    "currencyID": "KPW",
    "symbol": "₩",
    "name": "Korea (North) Won"
  },
  {
    "currencyID": "KRW",
    "symbol": "₩",
    "name": "Korea (South) Won"
  },
  {
    "currencyID": "KWD",
    "symbol": "د.ك",
    "name": "Kuwait Dinar"
  },
  {
    "currencyID": "KYD",
    "symbol": "$",
    "name": "Cayman Islands Dollar"
  },
  {
    "currencyID": "KZT",
    "symbol": "₸",
    "name": "Kazakhstan Tenge"
  },
  {
    "currencyID": "LAK",
    "symbol": "₭",
    "name": "Laos Kip"
  },
  {
    "currencyID": "LBP",
    "symbol": "ل.ل.‎",
    "name": "Lebanon Pound"
  },
  {
    "currencyID": "LKR",
    "symbol": "Rs",
    "name": "Sri Lanka Rupee"
  },
  {
    "currencyID": "LRD",
    "symbol": "L$",
    "name": "Liberia Dollar"
  },
  {
    "currencyID": "LSL",
    "symbol": "L",
    "name": "Lesotho Loti"
  },
  {
    "currencyID": "LYD",
    "symbol": "ل.د",
    "name": "Libya Dinar"
  },
  {
    "currencyID": "MAD",
    "symbol": "د. م.",
    "name": "Morocco Dirham"
  },
  {
    "currencyID": "MDL",
    "symbol": "L",
    "name": "Moldova Leu"
  },
  {
    "currencyID": "MGA",
    "symbol": "Ar",
    "name": "Madagascar Ariary"
  },
  {
    "currencyID": "MKD",
    "symbol": "Ден",
    "name": "Macedonia Denar"
  },
  {
    "currencyID": "MMK",
    "symbol": "K",
    "name": "Myanmar (Burma) Kyat"
  },
  {
    "currencyID": "MNT",
    "symbol": "₮",
    "name": "Mongolia Tughrik"
  },
  {
    "currencyID": "MOP",
    "symbol": "MOP$",
    "name": "Macau Pataca"
  },
  {
    "currencyID": "MRO",
    "symbol": "UM",
    "name": "Mauritania Ouguiya"
  },
  {
    "currencyID": "MUR",
    "symbol": "Rs",
    "name": "Mauritius Rupee"
  },
  {
    "currencyID": "MVR",
    "symbol": "Rf",
    "name": "Maldives (Maldive Islands) Rufiyaa"
  },
  {
    "currencyID": "MWK",
    "symbol": "MK",
    "name": "Malawi Kwacha"
  },
  {
    "currencyID": "MXN",
    "symbol": "Mex$",
    "name": "Mexico Peso"
  },
  {
    "currencyID": "MYR",
    "symbol": "RM",
    "name": "Malaysia Ringgit"
  },
  {
    "currencyID": "MZN",
    "symbol": "MT",
    "name": "Mozambique Metical"
  },
  {
    "currencyID": "NAD",
    "symbol": "N$",
    "name": "Namibia Dollar"
  },
  {
    "currencyID": "NGN",
    "symbol": "₦",
    "name": "Nigeria Naira"
  },
  {
    "currencyID": "NIO",
    "symbol": "C$",
    "name": "Nicaragua Cordoba"
  },
  {
    "currencyID": "NOK",
    "symbol": "kr",
    "name": "Norway Krone"
  },
  {
    "currencyID": "NPR",
    "symbol": "Rs.",
    "name": "Nepal Rupee"
  },
  {
    "currencyID": "NZD",
    "symbol": "$",
    "name": "New Zealand Dollar"
  },
  {
    "currencyID": "OMR",
    "symbol": "ر.ع.",
    "name": "Oman Rial"
  },
  {
    "currencyID": "PAB",
    "symbol": "B/.",
    "name": "Panama Balboa"
  },
  {
    "currencyID": "PEN",
    "symbol": "S/",
    "name": "Peru Nuevo Sol"
  },
  {
    "currencyID": "PGK",
    "symbol": "K",
    "name": "Papua New Guinea Kina"
  },
  {
    "currencyID": "PHP",
    "symbol": "₱",
    "name": "Philippines Peso"
  },
  {
    "currencyID": "PKR",
    "symbol": "Rs",
    "name": "Pakistan Rupee"
  },
  {
    "currencyID": "PLN",
    "symbol": "zł",
    "name": "Poland Zloty"
  },
  {
    "currencyID": "PYG",
    "symbol": "₲",
    "name": "Paraguay Guarani"
  },
  {
    "currencyID": "QAR",
    "symbol": "ر.ق",
    "name": "Qatar Riyal"
  },
  {
    "currencyID": "RON",
    "symbol": "L",
    "name": "Romania New Leu"
  },
  {
    "currencyID": "RSD",
    "symbol": "din",
    "name": "Serbia Dinar"
  },
  {
    "currencyID": "RUB",
    "symbol": "₽",
    "name": "Russia Ruble"
  },
  {
    "currencyID": "RWF",
    "symbol": "FRw",
    "name": "Rwanda Franc"
  },
  {
    "currencyID": "SAR",
    "symbol": "﷼‎",
    "name": "Saudi Arabia Riyal"
  },
  {
    "currencyID": "SBD",
    "symbol": "Si$",
    "name": "Solomon Islands Dollar"
  },
  {
    "currencyID": "SCR",
    "symbol": "SR",
    "name": "Seychelles Rupee"
  },
  {
    "currencyID": "SDG",
    "symbol": "ج.س.",
    "name": "Sudan Pound"
  },
  {
    "currencyID": "SEK",
    "symbol": "kr",
    "name": "Sweden Krona"
  },
  {
    "currencyID": "SGD",
    "symbol": "S$",
    "name": "Singapore Dollar"
  },
  {
    "currencyID": "SHP",
    "symbol": "£",
    "name": "Saint Helena Pound"
  },
  {
    "currencyID": "SLL",
    "symbol": "Le",
    "name": "Sierra Leone Leone"
  },
  {
    "currencyID": "SOS",
    "symbol": "Sh.so.",
    "name": "Somalia Shilling"
  },
  {
    "currencyID": "SLS",
    "symbol": "Sl. Sh.",
    "name": "Somaliland Shilling"
  },
  {
    "currencyID": "SRD",
    "symbol": "$",
    "name": "Suriname Dollar"
  },
  {
    "currencyID": "STD",
    "symbol": "Db",
    "name": "São Tomé and Príncipe Dobra"
  },
  {
    "currencyID": "SVC",
    "symbol": "C",
    "name": "El Salvador Colon"
  },
  {
    "currencyID": "SYP",
    "symbol": "£S",
    "name": "Syria Pound"
  },
  {
    "currencyID": "SZL",
    "symbol": "E",
    "name": "Swaziland Lilangeni"
  },
  {
    "currencyID": "THB",
    "symbol": "฿",
    "name": "Thailand Baht"
  },
  {
    "currencyID": "TJS",
    "symbol": "ЅM",
    "name": "Tajikistan Somoni"
  },
  {
    "currencyID": "TMT",
    "symbol": "T",
    "name": "Turkmenistan Manat"
  },
  {
    "currencyID": "TND",
    "symbol": "د.ت",
    "name": "Tunisia Dinar"
  },
  {
    "currencyID": "TOP",
    "symbol": "PT",
    "name": "Tonga Pa'anga"
  },
  {
    "currencyID": "TRY",
    "symbol": "₺",
    "name": "Turkey Lira"
  },
  {
    "currencyID": "TTD",
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar"
  },
  {
    "currencyID": "TVD",
    "symbol": "TV$",
    "name": "Tuvalu Dollar"
  },
  {
    "currencyID": "TWD",
    "symbol": "NT$",
    "name": "Taiwan New Dollar"
  },
  {
    "currencyID": "TZS",
    "symbol": "TSh",
    "name": "Tanzania Shilling"
  },
  {
    "currencyID": "UAH",
    "symbol": "₴",
    "name": "Ukraine Hryvnia"
  },
  {
    "currencyID": "UGX",
    "symbol": "USh",
    "name": "Uganda Shilling"
  },
  {
    "currencyID": "USD",
    "symbol": "$",
    "name": "United States Dollar"
  },
  {
    "currencyID": "UYU",
    "symbol": "$U",
    "name": "Uruguay Peso"
  },
  {
    "currencyID": "UZS",
    "symbol": "лв",
    "name": "Uzbekistan Som"
  },
  {
    "currencyID": "VEF",
    "symbol": "Bs.",
    "name": "Venezuela Bolivar"
  },
  {
    "currencyID": "VND",
    "symbol": "₫",
    "name": "Vietnam Dong"
  },
  {
    "currencyID": "VUV",
    "symbol": "VT",
    "name": "Vanuatu Vatu"
  },
  {
    "currencyID": "WST",
    "symbol": "SAT",
    "name": "Samoa Tala"
  },
  {
    "currencyID": "XCD",
    "symbol": "$",
    "name": "East Caribbean Dollar"
  },
  {
    "currencyID": "YER",
    "symbol": "﷼",
    "name": "Yemen Rial"
  },
  {
    "currencyID": "ZAR",
    "symbol": "R",
    "name": "South Africa Rand"
  },
  {
    "currencyID": "ZMW",
    "symbol": "ZK",
    "name": "Zambia Kwacha"
  },
  {
    "currencyID": "ZWD",
    "symbol": "Z$",
    "name": "Zimbabwe Dollar"
  }
]

export let countryData = [
  {
    type: "Countries",
    currency_code: "AFN-Afghanistan Afghani",
    currency_symbol: "؋",
    country_nm: "Afghanistan",
  },
  {
    type: "Countries",
    currency_code: "ALL-Albania Lek",
    currency_symbol: "Lek",
    country_nm: "Albania",
  },
  {
    type: "Countries",
    currency_code: "AMD-Armenia Dram",
    currency_symbol: "֏",
    country_nm: "Armenia",
  },
  {
    type: "Countries",
    currency_code: "AOA-Angola Kwanza",
    currency_symbol: "Kz",
    country_nm: "Angola",
  },
  {
    type: "Countries",
    currency_code: "ARS-Argentina Peso",
    currency_symbol: "$",
    country_nm: "Argentina",
  },
  {
    type: "Countries",
    currency_code: "AUD-Australia Dollar",
    currency_symbol: "$",
    country_nm: "Australia",
  },
  {
    type: "Countries",
    currency_code: "AWG-Aruba Guilder",
    currency_symbol: "ƒ",
    country_nm: "Aruba",
  },
  {
    type: "Countries",
    currency_code: "AZN-Azerbaijan New Manat",
    currency_symbol: "₼",
    country_nm: "Azerbaijan",
  },
  {
    type: "Countries",
    currency_code: "BAM-Bosnia and Herzegovina Convertible Marka",
    currency_symbol: "KM",
    country_nm: "Bosnia and Herzegovina",
  },
  {
    type: "Countries",
    currency_code: "BBD-Barbados Dollar",
    currency_symbol: "Bds$",
    country_nm: "Barbados",
  },
  {
    type: "Countries",
    currency_code: "BDT-Bangladesh Taka",
    currency_symbol: "৳",
    country_nm: "Bangladesh",
  },
  {
    type: "Countries",
    currency_code: "BGN-Bulgaria Lev",
    currency_symbol: "Лв",
    country_nm: "Bulgaria",
  },
  {
    type: "Countries",
    currency_code: "BHD-Bahrain Dinar",
    currency_symbol: ".د.ب",
    country_nm: "Bahrain",
  },
  {
    type: "Countries",
    currency_code: "BIF-Burundi Franc",
    currency_symbol: "FBu",
    country_nm: "Burundi",
  },
  {
    type: "Countries",
    currency_code: "BMD-Bermuda Dollar",
    currency_symbol: "$",
    country_nm: "Bermuda",
  },
  {
    type: "Countries",
    currency_code: "BND-Brunei Darussalam Dollar",
    currency_symbol: "B$",
    country_nm: "Brunei Darussalam",
  },
  {
    type: "Countries",
    currency_code: "BOB-Bolivia Boliviano",
    currency_symbol: "Bs",
    country_nm: "Bolivia",
  },
  {
    type: "Countries",
    currency_code: "BRL-Brazil Real",
    currency_symbol: "R$",
    country_nm: "Brazil",
  },
  {
    type: "Countries",
    currency_code: "BSD-Bahamas Dollar",
    currency_symbol: "B$",
    country_nm: "Bahamas",
  },
  {
    type: "Countries",
    currency_code: "BTN-Bhutan Ngultrum",
    currency_symbol: "Nu.",
    country_nm: "Bhutan",
  },
  {
    type: "Countries",
    currency_code: "BWP-Botswana Pula",
    currency_symbol: "P",
    country_nm: "Botswana",
  },
  {
    type: "Countries",
    currency_code: "BYR-Belarus Ruble",
    currency_symbol: "Br",
    country_nm: "Belarus",
  },
  {
    type: "Countries",
    currency_code: "BZD-Belize Dollar",
    currency_symbol: "$",
    country_nm: "Belize",
  },
  {
    type: "Countries",
    currency_code: "CAD-Canada Dollar",
    currency_symbol: "C$",
    country_nm: "Canada",
  },
  {
    type: "Countries",
    currency_code: "CDF-Congo/Kinshasa Franc",
    currency_symbol: "FC",
    country_nm: "Democratic Republic of the Congo",
  },
  {
    type: "Countries",
    currency_code: "CHF-Switzerland Franc",
    currency_symbol: "Fr.",
    country_nm: "Switzerland",
  },
  {
    type: "Countries",
    currency_code: "CLP-Chile Peso",
    currency_symbol: "$",
    country_nm: "Chile",
  },
  {
    type: "Countries",
    currency_code: "CNY-China Yuan Renminbi",
    currency_symbol: "¥",
    country_nm: "China",
  },
  {
    type: "Countries",
    currency_code: "COP-Colombia Peso",
    currency_symbol: "$",
    country_nm: "Colombia",
  },
  {
    type: "Countries",
    currency_code: "CRC-Costa Rica Colon",
    currency_symbol: "₡",
    country_nm: "Costa Rica",
  },
  {
    type: "Countries",
    currency_code: "CUP-Cuba Peso",
    currency_symbol: "$MN",
    country_nm: "Cuba",
  },
  {
    type: "Countries",
    currency_code: "CVE-Cape Verde Escudo",
    currency_symbol: "$",
    country_nm: "Republic of Cape Verde",
  },
  {
    type: "Countries",
    currency_code: "CZK-Czech Republic Koruna",
    currency_symbol: "Kč",
    country_nm: "Czech Republic",
  },
  {
    type: "Countries",
    currency_code: "DJF-Djibouti Franc",
    currency_symbol: "Fdj",
    country_nm: "Djibouti",
  },
  {
    type: "Countries",
    currency_code: "DKK-Denmark Krone",
    currency_symbol: "Kr.",
    country_nm: "Denmark",
  },
  {
    type: "Countries",
    currency_code: "DOP-Dominican Republic Peso",
    currency_symbol: "RD$",
    country_nm: "Dominican Republic",
  },
  {
    type: "Countries",
    currency_code: "DZD-Algeria Dinar",
    currency_symbol: "دج",
    country_nm: "Algeria",
  },
  {
    type: "Countries",
    currency_code: "EGP-Egypt Pound",
    currency_symbol: "E£",
    country_nm: "Egypt",
  },
  {
    type: "Countries",
    currency_code: "ERN-Eritrea Nakfa",
    currency_symbol: "نافكا",
    country_nm: "Eritrea",
  },
  {
    type: "Countries",
    currency_code: "ETB-Ethiopia Birr",
    currency_symbol: "ብር",
    country_nm: "Ethiopia",
  },
  {
    type: "Countries",
    currency_code: "EUR-Euro Member Countries",
    currency_symbol: "€",
    country_nm: "Euro Member Countries",
  },
  {
    type: "Countries",
    currency_code: "FJD-Fiji Dollar",
    currency_symbol: "FJ$",
    country_nm: "Fiji",
  },
  {
    type: "Countries",
    currency_code: "FKP-Falkland Islands (Malvinas) Pound",
    currency_symbol: "£",
    country_nm: "Falkland Islands (Malvinas)",
  },
  {
    type: "Countries",
    currency_code: "GBP-United Kingdom Pound",
    currency_symbol: "£",
    country_nm: "United Kingdom (UK)",
  },
  {
    type: "Countries",
    currency_code: "GEL-Georgia Lari",
    currency_symbol: "ლ",
    country_nm: "Georgia",
  },
  {
    type: "Countries",
    currency_code: "GGP-Guernsey Pound",
    currency_symbol: "£",
    country_nm: "Guernsey",
  },
  {
    type: "Countries",
    currency_code: "GHS-Ghana Cedi",
    currency_symbol: "GH₵",
    country_nm: "Ghana",
  },
  {
    type: "Countries",
    currency_code: "GIP-Gibraltar Pound",
    currency_symbol: "£",
    country_nm: "Gibraltar",
  },
  {
    type: "Countries",
    currency_code: "GMD-Gambia Dalasi",
    currency_symbol: "D",
    country_nm: "Gambia",
  },
  {
    type: "Countries",
    currency_code: "GNF-Guinea Franc",
    currency_symbol: "GFr",
    country_nm: "Guinea",
  },
  {
    type: "Countries",
    currency_code: "GTQ-Guatemala Quetzal",
    currency_symbol: "Q",
    country_nm: "Guatemala",
  },
  {
    type: "Countries",
    currency_code: "GYD-Guyana Dollar",
    currency_symbol: "G$",
    country_nm: "Guyana",
  },
  {
    type: "Countries",
    currency_code: "HKD-Hong Kong Dollar",
    currency_symbol: "HK$",
    country_nm: "Hong Kong",
  },
  {
    type: "Countries",
    currency_code: "HNL-Honduras Lempira",
    currency_symbol: "L",
    country_nm: "Honduras",
  },
  {
    type: "Countries",
    currency_code: "HRK-Croatia Kuna",
    currency_symbol: "kn",
    country_nm: "Croatia",
  },
  {
    type: "Countries",
    currency_code: "HTG-Haiti Gourde",
    currency_symbol: "G",
    country_nm: "Haiti",
  },
  {
    type: "Countries",
    currency_code: "HUF-Hungary Forint",
    currency_symbol: "Ft",
    country_nm: "Hungary",
  },
  {
    type: "Countries",
    currency_code: "IDR-Indonesia Rupiah",
    currency_symbol: "Rp",
    country_nm: "Indonesia",
  },
  {
    type: "Countries",
    currency_code: "ILS-Israel Shekel",
    currency_symbol: "₪",
    country_nm: "Israel",
  },
  {
    type: "Countries",
    currency_code: "IMP-Isle of Man Pound",
    currency_symbol: "£",
    country_nm: "Isle of Man",
  },
  {
    type: "Countries",
    currency_code: "INR-India Rupee",
    currency_symbol: "₹",
    country_nm: "India",
  },
  {
    type: "Countries",
    currency_code: "IQD-Iraq Dinar",
    currency_symbol: "ع.د",
    country_nm: "Iraq",
  },
  {
    type: "Countries",
    currency_code: "IRR-Iran Rial",
    currency_symbol: "﷼",
    country_nm: "Islamic Republic of Iran",
  },
  {
    type: "Countries",
    currency_code: "ISK-Iceland Krona",
    currency_symbol: "kr",
    country_nm: "Iceland",
  },
  {
    type: "Countries",
    currency_code: "JEP-Jersey Pound",
    currency_symbol: "£",
    country_nm: "Jersey",
  },
  {
    type: "Countries",
    currency_code: "JMD-Jamaica Dollar",
    currency_symbol: "$",
    country_nm: "Jamaica",
  },
  {
    type: "Countries",
    currency_code: "JOD-Jordan Dinar",
    currency_symbol: "د.ا",
    country_nm: "Jordan",
  },
  {
    type: "Countries",
    currency_code: "JPY-Japan Yen",
    currency_symbol: "¥",
    country_nm: "Japan",
  },
  {
    type: "Countries",
    currency_code: "KES-Kenya Shilling",
    currency_symbol: "Ksh",
    country_nm: "Kenya",
  },
  {
    type: "Countries",
    currency_code: "KGS-Kyrgyzstan Som",
    currency_symbol: "Лв",
    country_nm: "Kyrgyzstan",
  },
  {
    type: "Countries",
    currency_code: "KHR-Cambodia Riel",
    currency_symbol: "៛",
    country_nm: "Cambodia",
  },
  {
    type: "Countries",
    currency_code: "KMF-Comoros Franc",
    currency_symbol: "CF",
    country_nm: "Comoros",
  },
  {
    type: "Countries",
    currency_code: "KPW-Korea (North) Won",
    currency_symbol: "₩",
    country_nm: "Democratic People's Republic of Korea",
  },
  {
    type: "Countries",
    currency_code: "KRW-Korea (South) Won",
    currency_symbol: "₩",
    country_nm: "Republic of Korea",
  },
  {
    type: "Countries",
    currency_code: "KWD-Kuwait Dinar",
    currency_symbol: "د.ك",
    country_nm: "Kuwait",
  },
  {
    type: "Countries",
    currency_code: "KYD-Cayman Islands Dollar",
    currency_symbol: "$",
    country_nm: "Cayman Islands",
  },
  {
    type: "Countries",
    currency_code: "KZT-Kazakhstan Tenge",
    currency_symbol: "₸",
    country_nm: "Kazakhstan",
  },
  {
    type: "Countries",
    currency_code: "LAK-Laos Kip",
    currency_symbol: "₭",
    country_nm: "Laos",
  },
  {
    type: "Countries",
    currency_code: "LBP-Lebanon Pound",
    currency_symbol: "ل.ل.‎",
    country_nm: "Lebanon",
  },
  {
    type: "Countries",
    currency_code: "LKR-Sri Lanka Rupee",
    currency_symbol: "Rs",
    country_nm: "Sri Lanka",
  },
  {
    type: "Countries",
    currency_code: "LRD-Liberia Dollar",
    currency_symbol: "L$",
    country_nm: "Liberia",
  },
  {
    type: "Countries",
    currency_code: "LSL-Lesotho Loti",
    currency_symbol: "L",
    country_nm: "Kingdom of Lesotho",
  },
  {
    type: "Countries",
    currency_code: "LYD-Libya Dinar",
    currency_symbol: "ل.د",
    country_nm: "Libya",
  },
  {
    type: "Countries",
    currency_code: "MAD-Morocco Dirham",
    currency_symbol: "د. م.",
    country_nm: "Morocco",
  },
  {
    type: "Countries",
    currency_code: "MDL-Moldova Leu",
    currency_symbol: "L",
    country_nm: "Moldova",
  },
  {
    type: "Countries",
    currency_code: "MGA-Madagascar Ariary",
    currency_symbol: "Ar",
    country_nm: "Madagascar",
  },
  {
    type: "Countries",
    currency_code: "MKD-Macedonia Denar",
    currency_symbol: "Ден",
    country_nm: "Republic of Macedonia",
  },
  {
    type: "Countries",
    currency_code: "MMK-Myanmar (Burma) Kyat",
    currency_symbol: "K",
    country_nm: "Myanmar (Burma)",
  },
  {
    type: "Countries",
    currency_code: "MNT-Mongolia Tughrik",
    currency_symbol: "₮",
    country_nm: "Mongolia",
  },
  {
    type: "Countries",
    currency_code: "MOP-Macau Pataca",
    currency_symbol: "MOP$",
    country_nm: "Macau",
  },
  {
    type: "Countries",
    currency_code: "MRO-Mauritania Ouguiya",
    currency_symbol: "UM",
    country_nm: "Mauritania",
  },
  {
    type: "Countries",
    currency_code: "MUR-Mauritius Rupee",
    currency_symbol: "Rs",
    country_nm: "Mauritius",
  },
  {
    type: "Countries",
    currency_code: "MVR-Maldives (Maldive Islands) Rufiyaa",
    currency_symbol: "Rf",
    country_nm: "Maldives",
  },
  {
    type: "Countries",
    currency_code: "MWK-Malawi Kwacha",
    currency_symbol: "MK",
    country_nm: "Malawi",
  },
  {
    type: "Countries",
    currency_code: "MXN-Mexico Peso",
    currency_symbol: "Mex$",
    country_nm: "Mexico",
  },
  {
    type: "Countries",
    currency_code: "MYR-Malaysia Ringgit",
    currency_symbol: "RM",
    country_nm: "Malaysia",
  },
  {
    type: "Countries",
    currency_code: "MZN-Mozambique Metical",
    currency_symbol: "MT",
    country_nm: "Mozambique",
  },
  {
    type: "Countries",
    currency_code: "NAD-Namibia Dollar",
    currency_symbol: "N$",
    country_nm: "Namibia",
  },
  {
    type: "Countries",
    currency_code: "NGN-Nigeria Naira",
    currency_symbol: "₦",
    country_nm: "Nigeria",
  },
  {
    type: "Countries",
    currency_code: "NIO-Nicaragua Cordoba",
    currency_symbol: "C$",
    country_nm: "Nicaragua",
  },
  {
    type: "Countries",
    currency_code: "NOK-Norway Krone",
    currency_symbol: "kr",
    country_nm: "Norway",
  },
  {
    type: "Countries",
    currency_code: "NPR-Nepal Rupee",
    currency_symbol: "Rs.",
    country_nm: "Nepal",
  },
  {
    type: "Countries",
    currency_code: "NZD-New Zealand Dollar",
    currency_symbol: "$",
    country_nm: "New Zealand",
  },
  {
    type: "Countries",
    currency_code: "OMR-Oman Rial",
    currency_symbol: "ر.ع.",
    country_nm: "Oman",
  },
  {
    type: "Countries",
    currency_code: "PAB-Panama Balboa",
    currency_symbol: "B/.",
    country_nm: "Panama",
  },
  {
    type: "Countries",
    currency_code: "PEN-Peru Nuevo Sol",
    currency_symbol: "S/",
    country_nm: "Peru",
  },
  {
    type: "Countries",
    currency_code: "PGK-Papua New Guinea Kina",
    currency_symbol: "K",
    country_nm: "Papua New Guinea",
  },
  {
    type: "Countries",
    currency_code: "PHP-Philippines Peso",
    currency_symbol: "₱",
    country_nm: "Philippines",
  },
  {
    type: "Countries",
    currency_code: "PKR-Pakistan Rupee",
    currency_symbol: "Rs",
    country_nm: "Pakistan",
  },
  {
    type: "Countries",
    currency_code: "PLN-Poland Zloty",
    currency_symbol: "zł",
    country_nm: "Poland",
  },
  {
    type: "Countries",
    currency_code: "PYG-Paraguay Guarani",
    currency_symbol: "₲",
    country_nm: "Paraguay",
  },
  {
    type: "Countries",
    currency_code: "QAR-Qatar Riyal",
    currency_symbol: "ر.ق",
    country_nm: "Qatar",
  },
  {
    type: "Countries",
    currency_code: "RON-Romania New Leu",
    currency_symbol: "L",
    country_nm: "Romania",
  },
  {
    type: "Countries",
    currency_code: "RSD-Serbia Dinar",
    currency_symbol: "din",
    country_nm: "Serbia",
  },
  {
    type: "Countries",
    currency_code: "RUB-Russia Ruble",
    currency_symbol: "₽",
    country_nm: "Russia",
  },
  {
    type: "Countries",
    currency_code: "RWF-Rwanda Franc",
    currency_symbol: "FRw",
    country_nm: "Rwanda",
  },
  {
    type: "Countries",
    currency_code: "SAR-Saudi Arabia Riyal",
    currency_symbol: "﷼‎",
    country_nm: "Saudi Arabia",
  },
  {
    type: "Countries",
    currency_code: "SBD-Solomon Islands Dollar",
    currency_symbol: "Si$",
    country_nm: "Solomon Islands",
  },
  {
    type: "Countries",
    currency_code: "SCR-Seychelles Rupee",
    currency_symbol: "SR",
    country_nm: "Seychelles",
  },
  {
    type: "Countries",
    currency_code: "SDG-Sudan Pound",
    currency_symbol: "ج.س.",
    country_nm: "Republic of the Sudan",
  },
  {
    type: "Countries",
    currency_code: "SEK-Sweden Krona",
    currency_symbol: "kr",
    country_nm: "Sweden",
  },
  {
    type: "Countries",
    currency_code: "SGD-Singapore Dollar",
    currency_symbol: "S$",
    country_nm: "Singapore",
  },
  {
    type: "Countries",
    currency_code: "SHP-Saint Helena Pound",
    currency_symbol: "£",
    country_nm: "Saint Helena",
  },
  {
    type: "Countries",
    currency_code: "SLL-Sierra Leone Leone",
    currency_symbol: "Le",
    country_nm: "Sierra Leone",
  },
  {
    type: "Countries",
    currency_code: "SOS-Somalia Shilling",
    currency_symbol: "Sh.so.",
    country_nm: "Somalia",
  },
  {
    type: "Countries",
    currency_code: "SLS-Somaliland Shilling",
    currency_symbol: "Sl. Sh.",
    country_nm: "Somaliland",
  },
  {
    type: "Countries",
    currency_code: "SRD-Suriname Dollar",
    currency_symbol: "$",
    country_nm: "Suriname",
  },
  {
    type: "Countries",
    currency_code: "STD-São Tomé and Príncipe Dobra",
    currency_symbol: "Db",
    country_nm: "São Tomé and Príncipe",
  },
  {
    type: "Countries",
    currency_code: "SVC-El Salvador Colon",
    currency_symbol: "C",
    country_nm: "El Salvador",
  },
  {
    type: "Countries",
    currency_code: "SYP-Syria Pound",
    currency_symbol: "£S",
    country_nm: "Syria",
  },
  {
    type: "Countries",
    currency_code: "SZL-Swaziland Lilangeni",
    currency_symbol: "E",
    country_nm: "Swaziland",
  },
  {
    type: "Countries",
    currency_code: "THB-Thailand Baht",
    currency_symbol: "฿",
    country_nm: "Thailand",
  },
  {
    type: "Countries",
    currency_code: "TJS-Tajikistan Somoni",
    currency_symbol: "ЅM",
    country_nm: "Tajikistan",
  },
  {
    type: "Countries",
    currency_code: "TMT-Turkmenistan Manat",
    currency_symbol: "T",
    country_nm: "Turkmenistan",
  },
  {
    type: "Countries",
    currency_code: "TND-Tunisia Dinar",
    currency_symbol: "د.ت",
    country_nm: "Tunisia",
  },
  {
    type: "Countries",
    currency_code: "TOP-Tonga Pa'anga",
    currency_symbol: "PT",
    country_nm: "Tonga",
  },
  {
    type: "Countries",
    currency_code: "TRY-Turkey Lira",
    currency_symbol: "₺",
    country_nm: "Turkey",
  },
  {
    type: "Countries",
    currency_code: "TTD-Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
    country_nm: "Trinidad and Tobago",
  },
  {
    type: "Countries",
    currency_code: "TVD-Tuvalu Dollar",
    currency_symbol: "TV$",
    country_nm: "Tuvalu",
  },
  {
    type: "Countries",
    currency_code: "TWD-Taiwan New Dollar",
    currency_symbol: "NT$",
    country_nm: "Taiwan",
  },
  {
    type: "Countries",
    currency_code: "TZS-Tanzania Shilling",
    currency_symbol: "TSh",
    country_nm: "Tanzania",
  },
  {
    type: "Countries",
    currency_code: "UAH-Ukraine Hryvnia",
    currency_symbol: "₴",
    country_nm: "Ukraine",
  },
  {
    type: "Countries",
    currency_code: "UGX-Uganda Shilling",
    currency_symbol: "USh",
    country_nm: "Uganda",
  },
  {
    type: "Countries",
    currency_code: "AED-United Arab Emirates Dirham",
    currency_symbol: "د.إ",
    country_nm: "United Arab Emirates (UAE)",
  },
  {
    type: "Countries",
    currency_code: "USD-United States Dollar",
    currency_symbol: "$",
    country_nm: "United States Of America (USA)",
  },
  {
    type: "Countries",
    currency_code: "UYU-Uruguay Peso",
    currency_symbol: "$U",
    country_nm: "Uruguay",
  },
  {
    type: "Countries",
    currency_code: "UZS-Uzbekistan Som",
    currency_symbol: "лв",
    country_nm: "Uzbekistan",
  },
  {
    type: "Countries",
    currency_code: "VEF-Venezuela Bolivar",
    currency_symbol: "Bs.",
    country_nm: "Venezuela",
  },
  {
    type: "Countries",
    currency_code: "VND-Vietnam Dong",
    currency_symbol: "₫",
    country_nm: "Vietnam",
  },
  {
    type: "Countries",
    currency_code: "VUV-Vanuatu Vatu",
    currency_symbol: "VT",
    country_nm: "Vanuatu",
  },
  {
    type: "Countries",
    currency_code: "WST-Samoa Tala",
    currency_symbol: "SAT",
    country_nm: "Samoa",
  },
  {
    type: "Countries",
    currency_code: "XCD-East Caribbean Dollar",
    currency_symbol: "$",
    country_nm: "Eastern Caribbean States",
  },
  {
    type: "Countries",
    currency_code: "YER-Yemen Rial",
    currency_symbol: "﷼",
    country_nm: "Yemen",
  },
  {
    type: "Countries",
    currency_code: "ZAR-South Africa Rand",
    currency_symbol: "R",
    country_nm: "South Africa",
  },
  {
    type: "Countries",
    currency_code: "ZMW-Zambia Kwacha",
    currency_symbol: "ZK",
    country_nm: "Zambia",
  },
  {
    type: "Countries",
    currency_code: "ZWD-Zimbabwe Dollar",
    currency_symbol: "Z$",
    country_nm: "Zimbabwe",
  },
];

// Define the map explicitly with AccountType as keys and AccountCategory[] as values
export const accountTypeCategoryMap: Record<AccountType, AccountCategory[]> = {
  [AccountType.Assets]: [
    AccountCategory.Cash,
    AccountCategory.Bank,
    AccountCategory.CurrentAssets,
    AccountCategory.OtherCurrentAssets,
    AccountCategory.LongTermAssets,
  ],
  [AccountType.Liabilities]: [
    AccountCategory.CurrentLiabilities,
    AccountCategory.OtherCurrentLiabilities,
  ],
  [AccountType.Equity]: [AccountCategory.Equity],
  [AccountType.Income]: [AccountCategory.Income],
  [AccountType.Expense]: [
    AccountCategory.OperatingExpense,
    AccountCategory.CostOfGoodsSold,
  ],
  [AccountType.OtherIncome]: [AccountCategory.OtherIncome],
  [AccountType.OtherExpense]: [AccountCategory.OtherExpense],
};


